import { Base } from "@app/controllers/base";

// Connects to data-controller="store--clipboard"
export default class extends Base {
  static values = { text: String }
  static targets = ["icon"]

  async copy(event) {
    const btn = event.currentTarget
    const text = btn.dataset.clipboardTextValue || this.textValue

    try {
      await navigator.clipboard.writeText(text)
      this.showCopied(btn)
    } catch {
      // Fallback for older browsers
      const ta = document.createElement("textarea")
      ta.value = text
      ta.style.position = "fixed"
      ta.style.opacity = "0"
      document.body.appendChild(ta)
      ta.select()
      document.execCommand("copy")
      document.body.removeChild(ta)
      this.showCopied(btn)
    }
  }

  showCopied(btn) {
    const original = btn.innerHTML

    btn.innerHTML = `
      <svg class="h-3.5 w-3.5 text-emerald mr-1 inline" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>
      </svg>Copied!`

    btn.classList.add("text-emerald", "border-emerald")

    setTimeout(() => {
      btn.innerHTML = original
      btn.classList.remove("text-emerald", "border-emerald")
    }, 2000)
  }
}
